/* eslint-disable camelcase */
export default {
	query_condition: 'Query condition',
	search_result: 'Search result',
	// placeholder

	please_input: 'please input',
	please_select: 'please select',
	please_upload: 'please upload',
	please_search_and_select: 'Please search and select',
	begin_date: 'begin date',
	end_date: 'end date',
	end_datetime: 'end date',
	to: '-',
	copy: 'Copy',
	edit: 'Edit',
	new: 'New',
	delete: 'Delete',
	reapply: 'Reapply',
	back_to_draft: 'Back to draft',
	inquire: 'Inquire',
	reset: 'Reset',
	export: 'Export',
	import: 'Imoort',
	back: 'Back',
	save: 'Save',
	validate_account: 'Payment validate',
	sign_contract: 'Sign contract',
	please_input_xxx: 'please input {desc} ',
	please_select_xxx: 'please select {desc} ',
	please_upload_xxx: 'please upload {desc}',
	add: 'Add',
	retry: 'Retry',
	choice: 'Choice',
	agree: 'Agree',
	reject: 'Reject',
	transfer: 'Transfer',
	yes: 'Yes',
	no: 'No',
	comfirmed: 'Comfirmed',
	uncomfirm: 'Uncomfirm',
	confirm: 'Confirm',
	cancel: 'Cancel',
	tip: 'Tip',
	confirm_submit: 'Are you sure to submit?',
	confirm_delete: 'Are you sure to delete?',
	submit: 'Submit',
	subfix_success: ' success',
	subfix_fail: ' fail',
	// components里的翻译 开始
	please_input_keyword: 'please input keyword',
	please_input_keyword_to_search: 'please input keyword to search',
	no_file: 'No file',
	none: 'none',
	file: 'File',
	select_file: 'select file',
	file_limit_warning: 'File: {fileName}, file size is larger than {limitSize}, current size is {currentSize}',
	file_accept_warning: 'File: {fileName}, file type is incorrect, acceptable file type is {acceptType}',
	upload_fail: 'Upload fail',
	preview_fail: 'Preview fail',
	at_most_upload: 'At most upload {limit} files',
	delete_fail: 'Delete fail',
	delete_404_tip: 'The attachment resource cannot be found, please save/submit and confirm the deletion',
	tip_info: 'Tip information',
	attachment: 'attachment',
	cert_expired_type: 'Certificate validity type',
	regular: 'Regular',
	long_term: 'Long term',
	date: 'Date',
	start_date_title: 'Begin date',
	effect_date_title: 'Effect date',
	start_date: 'begin date',
	effect_date: 'start date',
	expired_date: 'expired date',
	more_condition: 'more condition',
	collapse: 'collapse',
	only_support_xxx: 'only support file type in {desc}',
	on_processing: 'There are still files being uploaded, please wait a moment',

	// component里的翻译 结束
	effective: 'Effective',
	invalid: 'Invalid',
	operate_successfully: 'Operate success',
	operate_failure: 'Operate fail',
	my_profile: 'My profile',
	last_update_date: 'Last update time',
	no_supplier_info: 'Failed to obtain supplier information, please contact Tencent procurement personnel',
	invite_register: 'Registration Invitation'
};
